// extracted by mini-css-extract-plugin
export var completionBody = "_it-2";
export var completionCard = "_it-0";
export var completionFooter = "_it-3";
export var completionTitle = "_it-1";